var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "signature-content", on: { click: _vm.openModal } },
        [
          _c("div", { staticClass: "signature-image" }, [
            _c("img", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.imgUrl,
                  expression: "imgUrl",
                },
              ],
              attrs: { id: _vm.imgId, src: _vm.imgUrl },
            }),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "signature-link" }, [
            _vm._v(_vm._s(_vm.message)),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "signaturePadModal",
          staticClass: "signature-modal",
          attrs: {
            modalId: _vm.modalId,
            showBtns: true,
            modalType: "medium-modal",
          },
        },
        [
          _c("div", { attrs: { slot: "modal-header" }, slot: "modal-header" }, [
            _c("p", { staticClass: "font-bold" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("hint.pleaseSignBelow")) +
                  "\n      "
              ),
            ]),
            _c("p"),
            _c("p", [_vm._v(" " + _vm._s(_vm.hintBeforeSignature))]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "signature-pad",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _c("canvas", {
                attrs: { id: _vm.padId, width: "600", height: "200" },
              }),
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn--orange",
                attrs: {
                  disabled: _vm.signaturePad
                    ? _vm.signaturePad.isEmpty()
                    : true,
                },
                on: { click: _vm.saveSignature },
              },
              [_vm._v(_vm._s(_vm.$t("action.confirm")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn--darkblue",
                on: { click: _vm.clearSignature },
              },
              [_vm._v(_vm._s(_vm.$t("action.clear")))]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }